export enum GlobalStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export namespace GlobalStatus {
  export const tabs = [undefined, GlobalStatus.ARCHIVED];
}
